function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { chunk } from 'lodash';
import { metrics } from '@netless/forge-room';
export function serializeSegment(segment) {
  return [segment.point.x, segment.point.y, segment.handleIn.x, segment.handleIn.y, segment.handleOut.x, segment.handleOut.y];
}
export function deserializeSegment(points, scope, matrix) {
  const segment = new scope.Segment(new scope.Point(points[0], points[1]), new scope.Point(points[2], points[3]), new scope.Point(points[4], points[5]));
  segment.transform(matrix);
  return segment;
}
export function serializePath(path) {
  return path.segments.reduce((result, next) => {
    result.push(...serializeSegment(next));
    return result;
  }, []);
}
export function deserializePath(points, scope, matrix) {
  const segmentGroup = chunk(points, 6);
  const path = new scope.Path();
  path.segments = segmentGroup.map(v => deserializeSegment(v, scope, matrix));
  return path;
}
class AnimationFrame {
  constructor() {
    _defineProperty(this, "callbacks", []);
    _defineProperty(this, "lastTime", 0);
    _defineProperty(this, "fps", 45);
    _defineProperty(this, "lastCallbackTime", 0);
    _defineProperty(this, "fpsBuffer", []);
    // 每 ~60 秒上报一次（45fps × 60s = 2700 帧）
    _defineProperty(this, "FPS_REPORT_INTERVAL", 2700);
    _defineProperty(this, "handleCallbacks", () => {
      const now = performance.now();
      if (this.lastCallbackTime > 0) {
        const actualFps = 1000 / (now - this.lastCallbackTime);
        this.fpsBuffer.push(actualFps);
        if (this.fpsBuffer.length >= this.FPS_REPORT_INTERVAL) {
          const avg = this.fpsBuffer.reduce((a, b) => a + b, 0) / this.fpsBuffer.length;
          const min = Math.min(...this.fpsBuffer);
          const sorted = [...this.fpsBuffer].sort((a, b) => a - b);
          const p90 = sorted[Math.floor(sorted.length * 0.9)];
          metrics().gauge('fps', Math.round(avg), {
            min: Math.round(min),
            p90: Math.round(p90)
          });
          this.fpsBuffer = [];
        }
      }
      this.lastCallbackTime = now;
      const functions = this.callbacks;
      this.callbacks = [];
      for (let i = 0, l = functions.length; i < l; i++) {
        functions[i]();
      }
    });
    _defineProperty(this, "addCallback", callback => {
      this.callbacks.push(callback);
    });
    _defineProperty(this, "handleFrame", time => {
      if (time - this.lastTime > 1000 / this.fps) {
        this.handleCallbacks();
        this.lastTime = time;
      }
      window.requestAnimationFrame(this.handleFrame);
    });
    window.requestAnimationFrame(this.handleFrame);
  }
}
export function requestAnimationFrameHook(scope) {
  const animationFrame = new AnimationFrame();

  // @ts-ignore
  scope.DomEvent.requestAnimationFrame = animationFrame.addCallback;
}
export function toTouchEvent(evt) {
  // @ts-ignore
  const nativeEvent = evt.event;
  if (nativeEvent && nativeEvent instanceof TouchEvent) {
    return nativeEvent;
  }
  return null;
}